module.exports = __webpack_public_path__ + "img/NASSAU.d8390397.png";